import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default _ref => {
  let {
    components,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, `描述一下你期望这个新功能的 API 是如何使用的，并提供一些代码示例。请用 `, /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://guides.github.com/features/mastering-markdown/"
    }
  }, `Markdown`), ` 格式化你的代码片段。`));
};